import { isPeopleLikeCameraType } from '../constants/adminPageConstants';

/*
 * Переход в раздел «Камеры» сразу на нужную локацию.
 *
 * FramesPage держит позицию в иерархии в sessionStorage (useNavigationState,
 * ключ framesPage_nav) и читает её при монтировании. Чтобы открыть конкретную
 * локацию, достаточно записать туда цепочку до неё — отдельного URL у уровня
 * нет.
 */
export const FRAMES_NAV_KEY = 'framesPage_nav';
export const EQUIPMENT_NAV_KEY = 'equipmentPage_nav';

/** path — { factory, workshop, section, room }, каждый { id, name }. */
export const buildLocationNavState = (path) => ({
  level: 'cameras',
  items: {
    factory: path.factory,
    workshop: path.workshop,
    section: path.section,
    room: path.room,
    camera: null,
  },
});

const writeLocation = (path) => {
  try {
    sessionStorage.setItem(FRAMES_NAV_KEY, JSON.stringify(buildLocationNavState(path)));
    return true;
  } catch {
    return false;
  }
};

export const openLocationInCameras = (navigate, path) => {
  writeLocation(path);
  navigate('/cameras');
};

/**
 * Диагностика камеры с «выходом из камеры» по Back.
 *
 * В историю сначала кладётся список камер её локации, затем сама диагностика.
 * Кнопка «Назад» браузера (и «Назад» на странице — там navigate(-1)) тогда
 * ведёт туда же, куда при обычном входе через «Камеры», а не обратно в
 * «Роли»; второй Back возвращает в «Роли».
 */
export const openCameraDiagnosticsFromLocation = (navigate, cameraId, path) => {
  writeLocation(path);
  navigate('/cameras');
  navigate(`/cameras/${cameraId}/diagnostics`);
};

/*
 * ТЗ №26: из «Камер» в админку. AdminPage держит позицию в sessionStorage
 * (ключ adminPage_nav); какую карточку открыть на правку (adminEdit) или
 * подсветить (adminHighlight) — передаётся в history state, чтобы reload
 * админки не повторял переход.
 */
export const ADMIN_NAV_KEY = 'adminPage_nav';

const writeAdminNav = (state) => {
  try {
    sessionStorage.setItem(ADMIN_NAV_KEY, JSON.stringify(state));
  } catch {
    /* без sessionStorage админка просто откроется с начала */
  }
};

/**
 * FE-CORR-07 FE-002: «Настройка локаций» — список локаций участка в админке,
 * текущая локация подсвечена. Форма правки не открывается.
 */
export const openLocationInAdmin = (navigate, path) => {
  writeAdminNav({
    level: 'rooms',
    items: { factory: path.factory, workshop: path.workshop, section: path.section, room: null, camera: null },
  });
  navigate('/admin', { state: { adminHighlight: { level: 'rooms', id: path.room.id } } });
};

/** Карточка камеры: камеры её локации в админке, сразу правка этой камеры. */
export const openCameraInAdmin = (navigate, camera, path) => {
  writeAdminNav(buildLocationNavState(path));
  navigate('/admin', { state: { adminEdit: { level: 'cameras', id: camera.id } } });
};

/**
 * ТЗ №27: камера в дереве ролей открывает «Камеры» сразу на её кадрах.
 * В history остаётся только /cameras, поэтому Back возвращает в «Роли».
 */
export const openCameraFrames = (navigate, camera, path) => {
  const state = buildLocationNavState(path);
  try {
    sessionStorage.setItem(FRAMES_NAV_KEY, JSON.stringify({
      level: 'frames',
      items: { ...state.items, camera: { id: Number.isFinite(Number(camera.id)) ? Number(camera.id) : camera.id, name: camera.name || '' } },
    }));
  } catch {
    /* без sessionStorage «Камеры» откроются с начала */
  }
  navigate('/cameras');
};

/**
 * FE-CORR-07 FE-004: превью камеры в админке открывает её кадры — в «Камерах»
 * для PEOPLE/PPE, в «Оборудовании» для EQUIPMENT. Переход push, поэтому Back
 * возвращает в админку на тот же список камер.
 */
export const cameraFramesTarget = (camera) => (
  isPeopleLikeCameraType(camera?.camera_type || camera?.type)
    ? { navKey: FRAMES_NAV_KEY, route: '/cameras' }
    : { navKey: EQUIPMENT_NAV_KEY, route: '/equipment' }
);

export const openCameraFramesFromAdmin = (navigate, camera, path) => {
  const { navKey, route } = cameraFramesTarget(camera);
  const state = buildLocationNavState(path);
  try {
    sessionStorage.setItem(navKey, JSON.stringify({
      level: 'frames',
      items: { ...state.items, camera: { id: camera.id, name: camera.name || '' } },
    }));
  } catch {
    /* без sessionStorage раздел откроется с начала */
  }
  navigate(route);
};
